import React from 'react';
import { Modal, Input, Form } from 'antd';

class RenombrarProductoModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    handleOkRename = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            console.log(values);

            const form = {
                idProducto: values.idProducto,
                nombre: values.nombre
            }
            //this.props.onSaveRename
            this.props.onSaveRename(form, this.props.form);
        })
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <Modal
                title="Renombrar producto"
                visible={this.props.visible}
                style={{ top: 30 }}
                width="500px"
                onCancel={this.props.onCancel}
                onOk={this.handleOkRename}
            >
                <Form>
                    <div className="row">
                        <div className="col-md-12">
                            {getFieldDecorator('idProducto', { initialValue: this.props.formValues.idProducto })(
                                <input type="hidden" />
                            )}

                            <Form.Item>
                                

                                {getFieldDecorator('nombre', {
                                    initialValue: this.props.formValues.nombre
                                })(
                                    <Input.TextArea
                                        placeholder="Ingrese nombre de producto"
                                        rows="4"
                                    />
                                )}
                            </Form.Item>

                        </div>
                    </div>
                </Form>
            </Modal>
        )

    }
}

export default Form.create()(RenombrarProductoModal)